module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "key-indicators"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "indicators-data-box"
  }, _vm._l((_vm.indicatorsData), function(item, index) {
    return _c('indicators-data-component', {
      key: index,
      attrs: {
        "data": item
      }
    })
  })), _vm._v(" "), _c('tips-component', {
    attrs: {
      "info": _vm.info
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3355fbd8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/serviceData/components/key-indicators/KeyIndicators.vue
// module id = 794
// module chunks = 0